import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EventoAdversoPage } from './evento-adverso';
import { AdverseEventsProvider } from '../../providers/adverses/adverses';
import { EventoAdversoPageProvider } from './evento-adverso.provider';
import { ListasProvider } from '../../providers/listas/listas';
import { BrMaskerModule } from 'brmasker-ionic-3';
import { UserProvider } from '../../providers/user/user';

@NgModule({
  declarations: [
    EventoAdversoPage,
  ],
  imports: [
    IonicPageModule.forChild(EventoAdversoPage),
    BrMaskerModule
  ],
  providers: [
    AdverseEventsProvider,
    EventoAdversoPageProvider,
    ListasProvider,
    UserProvider
  ]
})
export class EventoAdversoPageModule { }


// WEBPACK FOOTER //
// ./src/pages/evento-adverso/evento-adverso.module.ts